__turbopack_context__.v({
  "benefitCard": "DesignSprintsSection-module__pky0eG__benefitCard",
  "benefitIcon": "DesignSprintsSection-module__pky0eG__benefitIcon",
  "benefitLabel": "DesignSprintsSection-module__pky0eG__benefitLabel",
  "benefitsGrid": "DesignSprintsSection-module__pky0eG__benefitsGrid",
  "ctaRow": "DesignSprintsSection-module__pky0eG__ctaRow",
  "description": "DesignSprintsSection-module__pky0eG__description",
  "intro": "DesignSprintsSection-module__pky0eG__intro",
  "layout": "DesignSprintsSection-module__pky0eG__layout",
  "title": "DesignSprintsSection-module__pky0eG__title",
});
